import { noop } from 'lodash';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import * as services from '../services/session';


export const fetchActiveConversations = () => {
  const apiCallParams = {
    query: services.GET_ACTIVE_CONVERSATIONS,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data }) => data.session.activeConversations[0] || {})
    .catch(noop);
};
